<script>
    import { form as svForm, field } from "svelte-forms";
    import { required } from "svelte-forms/validators";
    import AssetsApi from "../../asset/assets.api.js";
    import { searchAssets } from "../../asset/assets.state.svelte.js";
    import { notificate } from "../../../services/notification.js";
    import { sortIPAddress } from "../../../js/utils.js";
    import { format } from "svelte-i18n";

    let formData = $state({});
    let formIsSubmitted = false;
    let searchResult = $state([]);
    let showSearchResult = $state(false);

    const addressPattern =
        /^(?:(?:[1-9]?[0-9]|1[0-9][0-9]|2(?:[0-4][0-9]|5[0-5]))\.){3}(?:[1-9]?[0-9]|1[0-9][0-9]|2(?:[0-4][0-9]|5[0-5]))(?:\/(?:[12]?[0-9]|3[0-2]))?$/;

    let results = $derived(searchResult.length);

    const asset_field = field("asset", "", [required()]);

    const myForm = svForm(asset_field);

    const orderSearchResult = (searchResults) => {
        return (searchResults = searchResults.sort((a, b) => {
            if (addressPattern.test(a.name) && addressPattern.test(b.name)) {
                let order = sortIPAddress([a, b]);
                if (JSON.stringify(order[0]) === JSON.stringify(a)) {
                    return -1;
                } else if (JSON.stringify(order[0]) === JSON.stringify(b)) {
                    return 1;
                } else {
                    return 0;
                }
            }
            if (addressPattern.test(a.name) && !addressPattern.test(b.name)) {
                return -1;
            }
            if (!addressPattern.test(a.name) && addressPattern.test(b.name)) {
                return 1;
            }
            return a.name.localeCompare(b.name);
        }));
    };

    const handleSubmit = async () => {
        event.preventDefault();
        formIsSubmitted = true;
        // reset API errors

        if (!$myForm.valid) {
            notificate("422");
            return false;
        }

        let assets = await searchAssets("v2/asset/", {
            filter: { name__like: formData.asset },
        });
        searchResult = orderSearchResult(assets);
        showSearchResult = true;
        formData.asset = null;
        document.body.addEventListener("click", handleBodyClick);
    };

    const handleBodyClick = () => {
        showSearchResult = false;
        document.body.removeEventListener("click", handleBodyClick);
    };

    const closeSearchPanel = (event) => {
        if (event.key == "Escape") {
            showSearchResult = false;
        } else {
            return;
        }
    };
</script>

<svelte:window onkeydown={closeSearchPanel} />

<form class="form-inline" novalidate onsubmit={handleSubmit}>
    <div class="input-group input-group-sm">
        <input
            class="form-control form-control-navbar"
            type="search"
            placeholder={$format("layout.header.asset_search")}
            aria-label="Search"
            bind:value={formData.asset}
        />

        <button class="btn btn-navbar" type="submit" aria-label="search asset">
            <i class="fas fa-search"></i>
        </button>
    </div>
</form>
{#if showSearchResult}
    <div
        class="dropdown-menu dropdown-menu-lg dropdown-menu-right show"
        style="left: inherit; right: 0px;"
    >
        <span class="dropdown-item dropdown-header">
            {results > 0 ? results : "No se encontraron"}
            {results === 1 ? "resultado" : "resultados"}:
            <i
                class="fa fa-times float-end"
                style="margin-top: 4px; cursor: pointer;"
                onclick={() => (showSearchResult = false)}
            ></i>
        </span>
        <div class="dropdown-divider"></div>
        {#each searchResult as asset}
            <a
                href={`/asset/${asset.kind}/${asset.id}`}
                class="dropdown-item"
                onclick={() => (showSearchResult = false)}
            >
                <i class={AssetsApi.AssetsIcons[asset.kind]}></i>
                {asset.name || asset.nickname}
            </a>
        {/each}
    </div>
{/if}

<style>

    .input-group-sm .btn {
        max-height: 30px;
    }
    .dropdown-menu.dropdown-menu-lg.dropdown-menu-right.show {
        height: auto;
        overflow-y: scroll;
        width: 450px !important;
        max-height: 410px;
        overflow-x: hidden;
        right: 15px !important;
        max-width: 450px !important;
        left: auto !important;
    }
</style>
